import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { registerNationalityOptions } from '../../../../../shared/utils/data/etablissments-data';
import { CandidatService } from '../../../../../services/candidat.service';
import { MissionService } from '../../../../../services/mission.service';
import { EstablishmentService } from '../../../../../services/establishment.service';
import { FlagService } from '../../../../../shared/services/flag.service';
import { SharedModule } from '../../../../../shared/shared.module';

@Component({
  selector: 'app-third-step-add-candidate',
  standalone: true,
  imports: [CommonModule, SharedModule, ReactiveFormsModule],
  templateUrl: './third-step-add-candidate.component.html',
  styleUrl: './third-step-add-candidate.component.scss'
})
export class ThirdStepAddCandidateComponent implements OnInit {
  @Input() form!: FormGroup;
  @Output() formValid = new EventEmitter<boolean>();
  @Input() firstStepForm: FormGroup;
  @Input() loading: boolean = false;

  nationalityOptions = registerNationalityOptions;
  documentForm: FormGroup;
  formData: FormData = new FormData();
  user: any;

  constructor(
    private candidatApi: CandidatService,
    private missionApi: MissionService,
    private establishmentService: EstablishmentService,
    private flag: FlagService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '') : {};
    this.documentForm = this.form.get('documents') as FormGroup;
    this.initForm();
    this.form.statusChanges.subscribe(() => {
      this.formValid.emit(this.form.valid);
    });
  }

  private initForm(): void {
    this.form.addControl('experience', this.fb.control('', [
      Validators.required,
      Validators.min(0),
      Validators.max(50)
    ]));
    this.form.addControl('identity_card', this.fb.control('', /*Validators.required*/));
    this.form.addControl('cv', this.fb.control('', /*Validators.required*/));
    this.form.addControl('diplomas', this.fb.control([]));
    this.form.addControl('certificates', this.fb.control([]));
    this.form.addControl('acceptcgu', this.fb.control(false, Validators.requiredTrue));
  }

  getIdentityCard(event: any): void {
    if (event && event.length > 0) {
      this.form.patchValue({ identity_card: event });
    }
  }

  getCV(event: any): void {
    if (event && event.length > 0) {
      this.form.patchValue({ cv: event[0] });
    }
  }

  getDiplomas(event: any): void {
    if (event && event.length > 0) {
      const currentDiplomas = this.form.get('diplomas')?.value || [];
      this.form.patchValue({ diplomas: [...currentDiplomas, ...event] });
    }
  }

  getCertificates(event: any): void {
    if (event && event.length > 0) {
      const currentCertificates = this.form.get('certificates')?.value || [];
      this.form.patchValue({ certificates: [...currentCertificates, ...event] });
    }
  }

  // Ajoute ici la logique d'upload, de gestion dynamique des validateurs, etc.
}
